import { Box } from '@byecode/ui/components/Box'
import React from 'react'

import { AnalyzeTraffic } from '@/containers/Analyze'

export const TrafficAnalyze = () => {
    return <AnalyzeTraffic />
}
